/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-16 17:45:05
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-30 15:39:42
 * @FilePath: /unifyxp-v2-store-portal/src/components/Modules/ArticleList/index.tsx
 */
import React from 'react';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import DragNDropColumns from 'src/components/DragNDropColumns';
import ContentDragItem from 'src/components/Modules/Components/ContentImageDragItem';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ArticleList = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    contentPageList,
    droppableId,
    draggableId,
    configFieldsList,
    staticData,
    onItemSort,
    onStaticChange,
    onItemAdd,
    onItemChange,
    onItemDelete,
    specificError,
    errKeys,
    disabled,
    hideEdit,
  } = props;
  const { titleTextColor } = staticData;

  const handleOnTextColorChange = (titleTextColor) => {
    if (onStaticChange) {
      onStaticChange({ titleTextColor });
    }
  };

  const handleOnListSort = (sort) => {
    const { newIndex, oldIndex } = sort.data;

    onItemSort(oldIndex, newIndex);
  };

  const handleItemOnAdd = () => {
    if (onItemAdd) {
      onItemAdd();
    }
  };

  const handleItemOnChange = (index, obj) => {
    if (onItemChange) {
      onItemChange(index, obj);
    }
  };

  const handleItemOnDelete = (index) => {
    if (onItemDelete) {
      onItemDelete(index);
    }
  };

  const canDelete = (configFieldsList || []).length > 1;
  const childGenerator = (data, index) => {
    const { summary, subtitle, image, contentPage = {}, draggableId } = data;

    const _specificError = Object.keys(specificError).reduce((pre, now) => {
      if (now.startsWith(draggableId)) {
        const v = specificError[now];

        const item = now.split(draggableId)[1];
        return { ...pre, [item]: v };
      }
      return pre;
    }, {});

    return (
      <ContentDragItem
        isPrimary={true}
        errKeys={errKeys}
        summary={summary}
        subtitle={subtitle}
        image={image}
        contentPageList={contentPageList}
        index={index}
        contentPage={contentPage}
        onChange={handleItemOnChange}
        {...(canDelete ? { onDelete: handleItemOnDelete } : {})}
        specificError={_specificError}
        isList
        disabled={disabled}
        hideEdit={hideEdit}
      />
    );
  };

  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper title={getI18n('general.backgroundColour')}>
          <ColorPicker
            multi
            onChange={handleOnTextColorChange}
            color={titleTextColor}
            disable={disabled}
          />
        </ItemWrapper>
      </Section>
      <DragNDropColumns
        hideTitle
        childGenerate={childGenerator}
        data={configFieldsList}
        droppableId={`${droppableId}${draggableId}FieldDropArea`}
        onSort={handleOnListSort}
        addText={`+${getI18n('general.addContentPage')}`}
        onAdd={handleItemOnAdd}
        disabled={disabled}
      />
    </React.Fragment>
  );
};
export default ArticleList;
